module.exports = __webpack_public_path__ + "img/location1.6c7bb19e.svg";